import { FilterOption } from '../types';

interface Props {
  active: FilterOption;
  setActive: (f: FilterOption) => void;
}

const FILTERS: FilterOption[] = [
  'All',
  '≥ 25%',
  'Dome',
  'Wind In',
  'Cold',
  'Low O/U',
];

export default function FilterPills({ active, setActive }: Props) {
  return (
    <div style={{
      display: 'flex',
      gap: 8,
      padding: '12px 20px',
      overflowX: 'auto',
      borderBottom: '1px solid #E4EAF8',
      background: '#fff',
    }}>
      {FILTERS.map(f => {
        const isActive = active === f;
        return (
          <button
            key={f}
            onClick={() => setActive(f)}
            style={{
              flexShrink: 0,
              padding: '6px 14px',
              borderRadius: 20,
              fontSize: '0.72rem',
              fontWeight: 600,
              cursor: 'pointer',
              border: '1.5px solid',
              transition: 'all 0.12s',
              borderColor: isActive ? '#1535A0' : '#E4EAF8',
              background:  isActive ? '#1535A0' : 'transparent',
              color:       isActive ? '#fff'    : '#8090B0',
            }}
          >
            {f}
          </button>
        );
      })}
    </div>
  );
}